import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Show a simple loading animation indicator
 * @export
 *
 * @category Loaders
 */
const Loading = (props) => {
    return _jsxs("div", { className: "uxpcore_loading uxp-loading-block", children: [" ", _jsx("div", { className: "uxpcore_loading__dot dot" }), " "] });
};
export default Loading;
